<template>
  <div>
    <custom-actions show-back>
      <el-form class="global-form" :model="formData" ref="form" label-width="120px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="订单ID" prop="orderId">
             {{ formData.orderId||'--' }}</el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="提货ID" prop="deliveryId">
             {{ formData.deliveryId||'--' }}</el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="供应商" prop="supplierName">
             {{ formData.supplierName||'--' }}</el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="invoiceAmount" label="发票金额(元)">
         {{formData.invoiceAmount||'--'}} </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item prop="invoiceTitle" label="发票抬头">
             {{formData.invoiceTitle||'--'}}   </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item prop="invoiceType" label="发票类型">
            {{formData.invoiceType||'--'}}   </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="附件" prop="fileList">
              <file-upload v-model="formData.fileList" readonly disabled></file-upload>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="发票" prop="invoiceList">
              <file-upload v-model="formData.invoiceList" readonly disabled></file-upload>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item class="btn">
              <el-button @click="$router.back()">取消</el-button>

            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </custom-actions>
  </div>
</template>

<script>
export default {
  name: 'purchaseInvoiceAdd',
  data () {
    return {
      specList: [],
      formData: {
        invoiceId: '', // 发票ID
        supplierId: '', // 供应商ID
        supplierName: '', // 供应商ID
        deliveryId: '', // 提货ID
        orderId: '', // 订单ID
        invoiceAmount: '', // 发票金额
        invoiceTitle: '', // 发票抬头
        invoiceType: '', // 发票类型
        status: '', // 状态1未开2已开
        isDel: '', // 是否删除，1为删除，0为未删除
        createUserId: '', // 创建人
        ctime: '', // 创建时间
        fileList: [], // 附件列表
        invoiceList: [] // 发票列表
      }

    }
  },
  created () {
    if (this.invoiceId) {
      this.loadData()
    }
  },
  computed: {
    invoiceId () {
      return this.$route.query.invoiceId
    }

  },
  methods: {

    loadData () {
      this.$axios.get(this.$apis.purchaseInvoice.selectYcInvoiceByInvoiceId, {
        params: { invoiceId: this.invoiceId }
      }).then(res => {
        res.fileList = res.fileList ? res.fileList : []
        res.invoiceList = res.invoiceList ? res.invoiceList : []

        this.formData = res || {}
      })
    }

  }
}
</script>

<style scoped lang='scss'>
::v-deep .el-form {

  .el-input-number,
  .el-select,
  .el-input,
  .el-date-editor {
    width: 100%;
    max-width: 400px;

  }
}

::v-deep .btn {
  .el-form-item__content {
    display: flex;
    margin-left: 0;
    align-items: center;
    justify-content: center;
  }
}
</style>
